<script setup>
// Casca de TODAS as rotas /settings/*. Cada pagina renderiza seu proprio
// BaseSettingsHeader (header unificado, ClickUp-style). Props headerTitle/
// icon/showBackButton aceitas pra compat com rotas existentes que ainda
// passam isso — sao ignoradas (o BaseSettingsHeader da pagina assume o
// papel de titulo).
defineProps({
  // headerTitle/icon/showBackButton/backUrl aceitos mas ignorados — compat
  // com rotas legadas. O BaseSettingsHeader da pagina assume o papel.
  // eslint-disable-next-line vue/no-unused-properties
  headerTitle: { type: String, default: '' },
  // eslint-disable-next-line vue/no-unused-properties
  icon: { type: String, default: '' },
  keepAlive: { type: Boolean, default: true },
  // eslint-disable-next-line vue/no-unused-properties
  showBackButton: { type: Boolean, default: false },
  // eslint-disable-next-line vue/no-unused-properties
  backUrl: { type: [String, Object], default: '' },
  fullWidth: { type: Boolean, default: false },
});
</script>

<template>
  <!-- Estrutura ClickUp-style: container flex-col que ocupa altura total
       + main scrollavel onde cada pagina renderiza seu proprio
       BaseSettingsHeader (header unificado). O SettingsHeader legacy
       foi removido pra evitar duplicacao de titulo. -->
  <div
    class="flex flex-1 flex-col h-full w-full bg-n-background overflow-hidden"
  >
    <main class="flex-1 min-h-0 overflow-auto">
      <div
        class="w-full"
        :class="{
          'px-6 sm:px-8 lg:px-12 pt-8 pb-12': !fullWidth,
        }"
      >
        <router-view v-slot="{ Component }">
          <component :is="Component" v-if="!keepAlive" :key="$route.fullPath" />
          <keep-alive v-else>
            <component :is="Component" :key="$route.fullPath" />
          </keep-alive>
        </router-view>
      </div>
    </main>
  </div>
</template>
